export default {
  text: '',
  show: false,
};
